var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWorkoutHistoryPlacholder = function SvgWorkoutHistoryPlacholder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 392,
    height: 149,
    viewBox: "0 0 392 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 197,
    height: 64,
    rx: 12,
    fill: "url(#a)",
    fillOpacity: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 40,
    height: 40,
    rx: 8,
    fill: "#111",
    fillOpacity: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 14,
    width: 116,
    height: 8,
    rx: 4,
    fill: "#111",
    fillOpacity: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 28,
    width: 60,
    height: 8,
    rx: 4,
    fill: "#111",
    fillOpacity: 0.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 42,
    width: 40,
    height: 8,
    rx: 4,
    fill: "#111",
    fillOpacity: 0.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 42,
    width: 40,
    height: 8,
    rx: 4,
    fill: "#111",
    fillOpacity: 0.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 77,
    width: 258,
    height: 72,
    rx: 12,
    fill: "url(#b)",
    fillOpacity: 0.2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 79,
    y: 89,
    width: 48,
    height: 48,
    rx: 8,
    fill: "#111",
    fillOpacity: 0.5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 139,
    y: 92,
    width: 150,
    height: 10,
    rx: 5,
    fill: "#111",
    fillOpacity: 0.5
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 139,
    y: 110,
    width: 60,
    height: 8,
    rx: 4,
    fill: "#111",
    fillOpacity: 0.5
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 139,
    y: 126,
    width: 40,
    height: 8,
    rx: 4,
    fill: "#111",
    fillOpacity: 0.5
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 189,
    y: 126,
    width: 40,
    height: 8,
    rx: 4,
    fill: "#111",
    fillOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 98.5,
    y1: 0,
    x2: 98.5,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 196,
    y1: 77,
    x2: 196,
    y2: 149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.1
  })))));
};
export { SvgWorkoutHistoryPlacholder as ReactComponent };
export default "data:image/svg+xml;base64,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";